import { render } from "./WhatsAppList.vue?vue&type=template&id=a4a2fac6&scoped=true"
import script from "./WhatsAppList.vue?vue&type=script&lang=js"
export * from "./WhatsAppList.vue?vue&type=script&lang=js"

import "./WhatsAppList.vue?vue&type=style&index=0&id=a4a2fac6&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a2fac6"]])

export default __exports__